import React, { Component } from "react";
import moment from 'moment'
import 'moment-timezone';
import FullCalendar from '@fullcalendar/react'
import { formatDate } from '@fullcalendar/core'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import listPlugin from '@fullcalendar/list'
import './day.css'
class DayCalendar extends Component {
    state = {
        weekendsVisible: true,
        calendar: '',
    }
    render() {
        const { upcomingEventsListday, events, numEvents } = this.props;
        const nowDate = new Date()
        return (
            <div className='cldtd_calendar_card'>
                <div className='cldtd_calendar_card_main_day'>
                    <div className='cldtd_calendar_card_DateDay'>
                        {moment(nowDate).format('dddd')},&nbsp;{moment(nowDate).format('D')}
                    </div>
                    <div className='cldtd_calendar_card_YearMonth'>
                        {moment(nowDate).format('MMMM')}&nbsp;
                        {moment(nowDate).format('YYYY')}
                    </div>
                </div>
                {this.renderSidebar()}
            </div>
        )
    }
    getVisibleRange() {
        const events = this.props.upcomingEventsListday;
        if (!events || events.length === 0) return undefined;
        const dates = events.map(e => new Date(e.start));
        const minDate = new Date(Math.min(...dates));
        const maxDate = new Date(Math.max(...dates));
        maxDate.setDate(maxDate.getDate() + 1);
        return {
            start: minDate.toISOString().split('T')[0],
            end: maxDate.toISOString().split('T')[0]
        };
    }
    renderSidebar() {
        const visibleRange = this.getVisibleRange();
        return (
            <div className='cldtd_calendar_card_sidebar_day'>
                <div className='cldtd_calendar_card_sidebar_section'>
                    <div className="cldtd_calendar_card_sidebar_date">Upcoming Events</div>
                    <div className="cldtd_calendar_card_eventSection">
                        <FullCalendar
                            plugins={[listPlugin]}
                            headerToolbar={{
                                left: '',
                                center: '',
                                right: ''
                            }}
                            initialView='listDay'
                            timeZone='local'
                            dayMaxEventRows={1}
                            events={this.props.upcomingEventsListday}
                            visibleRange={visibleRange}
                        />
                    </div>

                </div>
            </div>
        )
    }
}

export default DayCalendar

